module.exports = __webpack_public_path__ + "img/CHANGLIAN_LONT.56d415c3.png";